<mat-accordion class="custom-accordion full-grow-no-shrink-no-basis" [multi]="true">
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
      <mat-panel-title>
        Snippet Details
      </mat-panel-title>
    </mat-expansion-panel-header>
    <section *ngIf="snippets.length" class="flex flex-row justify-start items-start">
      <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput placeholder="" [(ngModel)]="data.input.name" required>
      </mat-form-field>

      <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
        <mat-label>Type*</mat-label>
        <mat-select (selectionChange)="onselectedSnippetTypeChange($event)" [(ngModel)]="selectedSnippetType"
                    placeholder="Select"
                    [disabled]="false"
        >
          <mat-option *ngFor="let op of snippets" [value]="op">
            {{op.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="platform-tool-add-container w-p-100"
           *ngIf="selectedSnippetType && selectedSnippetType.name !='Custom'">
        <div class="wrapper" *ngFor="let question of selectedSnippetType.metaData.Questions; let i = index">

          <mat-form-field class="w-p-100 hide" floatPlaceholder="always" floatLabel="always" appearance="outline">
            <mat-label>Title*</mat-label>
            <input matInput placeholder="" [(ngModel)]="question.title" disabled>

          </mat-form-field>

          <mat-form-field *ngIf="question.metaData" floatPlaceholder="always" floatLabel="always" appearance="outline">

            <mat-label>{{question.title}}</mat-label>

            <mat-select (selectionChange)="onDefaultSelectedOperatorChange($event, i,question)"
                        [(ngModel)]="question.metaData.SelectedOperatorId" placeholder="Select"
                        [disabled]="false"
            >
              <mat-option *ngFor="let op of applicableOperators" [value]="op.id">
                {{op.displayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field *ngIf="question.metaData && question.metaData.SelectedOperatorId=='MapQuestion'"
                          floatPlaceholder="always" floatLabel="always" appearance="outline">
            <mat-select (selectionChange)="onSelectedMapQuestionChange($event, i,question)"
                        [(ngModel)]="question.metaData.MapQuestionFieldKey" placeholder="Select a field"
                        [disabled]="false"
            >
              <mat-option *ngFor="let q of data.input.allQuestions" [value]="q.item.fieldKey">
                {{q.item.questionId}}. {{q.item.title}}.
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="question.metaData && question.metaData.SelectedOperatorId=='CreateQuestion'"
                          class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
            <mat-label>Value</mat-label>
            <input matInput placeholder="" [(ngModel)]="question.metaData.QuestionTitle" required>

          </mat-form-field>


          <!--        <div *ngIf="question.metaData && question.metaData.selectedOperatorId=='select-value'"  mat-menu-item class=""   (click)="onEdit(question)"  class="fake-input">-->
          <!--          <div *ngIf="item && item.cells && item.cells[question.fieldKey] && item.cells[question.fieldKey].displayText" class="input" matTooltip=""> {{item.cells[question.fieldKey].displayText}}</div>-->
          <!--          <i class="fas fa-caret-down"></i>-->
          <!--        </div>-->

          <app-platform-tool-dialog-definition-editor-container
            *ngIf="question.metaData && question.metaData.SelectedOperatorId=='Value'"
            [dialogField]="dialogField(question)"
            [inputForm]="inputForm"
            (fieldValueChange)="onFieldValueChange($event)"
            (fieldValidationChange)="onFieldValidationChange($event)"
            [extras]="{}"
          ></app-platform-tool-dialog-definition-editor-container>

        </div>
      </div>
      <div style="position: relative" class="editor-container w-p-100 flex flex-col full-grow-no-shrink-no-basis"
           *ngIf="selectedSnippetType && selectedSnippetType.name =='Custom'">
        <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
          <mat-label>Details</mat-label>
          <input matInput placeholder="Input" style="display: none"
                 particleAnalytics
                 analyticsCategory="choice-filter-modal-item-editor"
                 analyticsAction="entity-scope-input">
          <!--    TODO: Don't remove the following line. Need to update it with ckeditor5-->
          <!--          <ckeditor [ngModelOptions]="{standalone: true}"-->
          <!--                    [(ngModel)]="ckeditorContent"-->
          <!--                    [config]="ckeConfig"-->
          <!--                    [readonly]="false"-->
          <!--                    debounce="500">-->
          <!--          </ckeditor>-->
        </mat-form-field>

        <!--        <button class="rest-btn"  matTooltip="Reset">-->
        <!--          <i class="far fa-sync-alt"></i>-->
        <!--        </button>-->
      </div>
      <mat-checkbox [(ngModel)]="showLawChageReport" [checked]="showLawChageReport">Include Law Change Report(s)
      </mat-checkbox>
    </section>
  </mat-expansion-panel>
  <mat-expansion-panel *ngIf="showLawChageReport" (opened)="panelOpenState = true"
                       (closed)="panelOpenState = false">
    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
      <mat-panel-title>
        Law Change Report(s)
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>Pending Items.</p>
  </mat-expansion-panel>
</mat-accordion>



